import { Link } from 'react-router-dom'
import { APP_CONFIG } from '@/constants'

interface FooterProps {
  className?: string
}

export const Footer = ({ className = '' }: FooterProps) => {
  // TODO: When FINRA approves, make "SecondLane Securities LLC" a link to FINRA broker check page
  // const FINRA_BROKER_CHECK_URL = 'https://brokercheck.finra.org/...'
  const isFinraApproved = false // Set to true when FINRA approves

  return (
    <footer className={`border-t border-[rgba(45,41,35,0.12)] dark:border-[rgba(253,253,253,0.12)] bg-transparent py-6 md:py-8 ${className}`}>
      <div className="max-w-[99.5rem] mx-auto px-3 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
          {/* Left side: Contact email and links */}
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-6">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4">
              <span className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">
                For issues on the platform, contact:{' '}
                <a 
                  href={`mailto:${APP_CONFIG.SUPPORT_EMAIL}`}
                  className="underline decoration-solid hover:opacity-80 transition-opacity break-all"
                >
                  {APP_CONFIG.SUPPORT_EMAIL}
                </a>
              </span>
            </div>
            
            <div className="flex items-center gap-3 md:gap-4">
              <Link 
                to="/terms" 
                className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)] underline decoration-solid hover:opacity-80 transition-opacity"
              >
                Terms of Use
              </Link>
              <span className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.32)] dark:text-[rgba(253,253,253,0.32)]">|</span>
              <Link 
                to="/privacy" 
                className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)] underline decoration-solid hover:opacity-80 transition-opacity"
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Right side: Company name */}
          <div className="flex items-center md:justify-end">
            {isFinraApproved ? (
              <a
                href="#"
                className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)] underline decoration-solid hover:opacity-80 transition-opacity"
                // TODO: Replace # with FINRA_BROKER_CHECK_URL when FINRA approves
              >
                SecondLane Securities LLC
              </a>
            ) : (
              <span className="font-['Plus_Jakarta_Sans'] text-[12px] md:text-[13px] font-normal leading-[16px] md:leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">
                SecondLane Securities LLC
              </span>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}
